var _style, _polygon, _defs, _path, _path2, _polygon2, _polygon3, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEftaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250 100",
    style: {
      enableBackground: "new 0 0 250 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F4B216;}\n\t.st1{clip-path:url(#SVGID_2_);fill:#F5B318;}\n\t.st2{clip-path:url(#SVGID_2_);fill:#F4B216;}\n\t.st3{fill:#353282;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "21.36,15.2 25.58,25.64 98.65,25.81 98.68,15.38 "
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 250,
    height: 100
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.6,15.42c17.4,0.04,34.81,0.08,52.21,0.12c0,0-19.34,20.87-36.34,68.96c-0.15,0.42,0.6-2.3,2.12-8.03 c0,0,1.31-4.91,3.01-11.56c4.48-17.52,6.29-31.48,0.82-40.46C123.05,17.25,108.33,15.95,105.6,15.42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M166.73,15.57c-0.04,3.46-0.07,6.92-0.11,10.38l58.77,0.14l3.25-10.37L166.73,15.57z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "21.35,84.31 27.24,73.91 117.85,74.12 117.83,84.54  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "127.18,74.14 127.16,84.56 228.64,84.8 225.11,74.37  "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M27.77,36.08l17.79,0.04l1.86,7.05l-11.44-0.03l-0.01,3.25l10.38,0.02l-2.13,6.93l-8.27-0.02l-0.01,3.64 L48.25,57l-2.09,7.04L27.7,64L27.77,36.08z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M51.21,63.35l0.06-27.22l17.55,0.04l1.79,7.05L59.57,43.2l-0.01,3.87l10.07,0.02l-2.17,7.16l-7.95-0.02 l-0.02,7.82c0,0.81,0.04,1.12,0.27,2.05l-7.14,4.48C51.48,66.26,51.21,65.25,51.21,63.35z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M74.47,36.19l18.61,0.04l1.86,7.05l-7.09-0.02l-0.05,20.87l-8.19-0.02l0.05-20.87l-7.13-0.02L74.47,36.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M96.23,63c-0.9-2.33-1.4-5.46-1.39-8.48c0.03-11.04,6.59-18.26,16.62-18.24l6.43,0.02l1.9,7.05l-6.9-0.02 c-2.12,0-3.65,0.34-5.14,1.23c-0.67,0.39-1.29,0.85-1.73,1.35c-0.79,0.73-1.18,1.28-1.97,2.75l6,0.01l0.01-4.18l8.19,0.02 l-0.05,19.71l-8.19-0.02l0.02-8.33l-7.13-0.02c0.46,3.91,0.73,4.84,2.64,8.37l-6.63,4.36C97.71,66.29,96.78,64.39,96.23,63z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M153.99,36.71l18.39,0.04l1.84,6.97l-7.01-0.02l-0.05,20.62l-8.09-0.02l0.05-20.62l-7.05-0.02L153.99,36.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M188.67,36.79c-2.72,5.46-3.7,7.79-4.59,11.04c-0.39,1.53-0.74,3.71-0.75,4.86c-0.01,3.21,1.46,4.71,4.63,4.72 l2.98,0.01l0.05-20.62l8.05,0.02l-0.06,27.58l-13.16-0.03c-6.93-0.02-10.52-3.93-10.5-11.31c0-1.64,0.24-3.86,0.67-5.66 c0.71-3.48,1.56-5.66,4.05-10.63L188.67,36.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M210.76,43.81l-8.28-0.02l1.91-6.96l18.35,0.04l-9.3,20.6l9.06,0.02l-2.03,6.96l-19.05-0.04L210.76,43.81z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEftaLogo);
export default __webpack_public_path__ + "static/media/efta_logo.a0c09190c234ff150feb3baa0f5898ce.svg";
export { ForwardRef as ReactComponent };